import { Message } from '@ncss/message';
import { NL4InfoMessageType, NL4Info } from '@ncss/models';
import { ByteList } from 'byte-list';

export class NL4BLEInfoMessage extends Message {
    nl4Info: NL4Info;

    constructor(serialNumber: number, type?: number) {
        super();
        this.type = type || NL4InfoMessageType.REQUEST_INFO;
        this.nl4Info = new NL4Info(serialNumber);
    }

    public serialize(): ByteList {
        const bytes = super.serialize();
        this.nl4Info.serialize(bytes);
        return bytes;
    }

    public deserialize(bytes: ByteList): void {
        super.deserialize(bytes);
        this.nl4Info = new NL4Info(0);
        this.nl4Info.deserialize(bytes);
    }
}
